export const parseCommissionRate = (commission: string | undefined): number => {
    if (!commission) return 0;
    const cleaned = commission.trim().replace(",", ".");
    const parsed = Number.parseFloat(cleaned);
    return Number.isNaN(parsed) ? 0 : parsed / 100;
};